import React, { useRef } from "react";
import Navbar from "../Navbar/Navbar";
import Select from "../Select/Select"
import MobileStepper from "../Stepper/MobileStepper"

function TestCompatibilidad() {

  

  return (
    <div>
        <header>
          <Navbar/>
        </header>

        <main class="content" style={{ flex: 1 }}>
          <MobileStepper />
        </main>
        
        <footer class="text-center py-3">
          <h4 style={{ textAlign: 'center' }}>¡Muchas gracias por elegirnos!</h4>
        </footer>

    </div>);
}

export default TestCompatibilidad;
